import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import registerServiceWorker from './registerServiceWorker';

// CSS IMPORT ORDER - Critical for Tailwind to work!
// Legacy CSS must load BEFORE Tailwind to avoid specificity conflicts
//import './custom.css';      // 1. Legacy custom styles
//import './style.scss';       // 2. Legacy SCSS (7000+ lines)
import './index.css';        // 3. Tailwind CSS 4.x (MUST BE LAST for highest priority!) ✅

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const root = createRoot(rootElement);
root.render(
 // <React.StrictMode>
    <BrowserRouter basename={baseUrl} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <App />
    </BrowserRouter>
 // </React.StrictMode>
);

registerServiceWorker();
